<template>
  <Modal
    title="動画タグ 名寄せ"
    bottom-close-button-label="OK"
    :isCloseButtonDisabled="!canSubmit"
    @close="save"
    @dismiss="$emit('close')"
  >
    <template v-slot:body>
      <div>
        <div class="form-group">
          <label class="form-control-label group2">名寄せ元</label>
          <select class="form-control" :value="sourceTag.id" disabled>
            <option :value="sourceTag.id">{{sourceTag.tagName}}</option>
          </select>
        </div>
        <div class="form-group">
          <label class="form-control-label group2">名寄せ先</label>
          <select class="form-control" v-model="toTagId">
            <option :value="null"></option>
            <option v-for="e in selectableTargetTags" :key="e.id" :value="e.id">
              {{e.tagName}}
            </option>
          </select>
        </div>
        <p class="p2 warnings">
          名寄せした動画タグ情報は元に戻せないため、名寄せ元と名寄せ先に間違いが無いか十分に確認してから実行してください。
        </p>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import type { AdminTagIndexItem } from 'src/models/tag';

const props = defineProps<{
  sourceTag: AdminTagIndexItem;
  tags: AdminTagIndexItem[];
}>();

const emit = defineEmits<{
  (e: 'merge', payload: { sourceId: number; targetId: number }): void;
  (e: 'close'): void;
}>();

const toTagId = ref<number | null>(null);

const selectableTargetTags = computed<AdminTagIndexItem[]>(() => {
  return props.tags.filter(tag => tag.id !== props.sourceTag.id);
});
const canSubmit = computed<boolean>(() => toTagId.value !== null);

const save = (): void => {
  if (toTagId.value === null) return;

  emit('merge', { sourceId: props.sourceTag.id, targetId: toTagId.value });
};
</script>

<style lang="scss" scoped>
.warnings {
  color: red;
  font-size: 12px;
}
</style>
